<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <validation-provider
        :name="$t('commands.selectable.name')"
        rules="required"
        v-slot="{ errors }"
      >
        <label class="d-block">
          {{ $t('commands.selectable.name') }}
        </label>
        <textarea
          class="form-control"
          v-model="fieldData.name"
          rows="2"
        />
        <p v-if="errors" class="small text-danger">
          {{ errors[0] }}
        </p>
      </validation-provider>
    </validation-observer>
    <div class="rules mt-1">
      <b-form-group
        label="Requerido"
        label-for="groups"
      >
        <b-form-checkbox
          v-model="ruleRequired"
          name="chek-dispatch-alarm"
          switch
        >
        </b-form-checkbox>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {BFormCheckbox, BFormGroup} from "bootstrap-vue";
export default {
  props: {
    fieldData: {
      type: Object
    },
    showPreview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BFormCheckbox, BFormGroup,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      fieldName: null,
      ruleRequired: false
    }
  },
  mounted() {
    if (this.fieldData.rules && this.fieldData.rules.includes('required')) {
      this.ruleRequired = this.fieldData.rules === 'required';
    }
  },
  computed: {
    rules: {
      get() {
        return `${this.ruleRequired ? 'required' : ''}`
      },
      set(value) {
        this.ruleRequired = value;
      }
    }
  },
  watch: {
    rules(val) {
      this.$set(this.fieldData, 'rules', val);
    }
  },
}
</script>
